export const BEGIN_REQUEST = '@@od/store/requests/beginRequest';
export const PUT_REQUEST_SUCCESS = '@@od/store/requests/putRequestSuccess';
export const PUT_REQUEST_ERROR = '@@od/store/requests/putRequestError';
